import React from "react";
import { useNavigate } from "react-router-dom";

import RecruiterSummary from "../components/scouting/RecruiterSummary";
import { useAuth } from "../context/AuthContext";
import { useNotifications } from "../components/layout/routing/AppShell";

const RecruiterSummaryRoute = () => {
  const navigate = useNavigate();
  const {
    linkedAthletes,
    scoutData,
    scoutTrackingData,
    activeSearchId,
  } = useAuth();
  const { openNotifications } = useNotifications();

  const handleOpenAthleteDetail = (athleteSummary) => {
    const athleteId =
      athleteSummary?.athlete_id ||
      athleteSummary?.athleteId ||
      athleteSummary?.athlete?.id ||
      athleteSummary?.id;
    if (!athleteId) {
      console.error("No se pudo identificar el atleta para abrir el detalle.");
      return;
    }
    navigate(`/scout/athletes/${athleteId}`);
  };

  return (
    <RecruiterSummary
      athletes={linkedAthletes}
      scoutProfile={scoutData}
      scoutTrackingData={scoutTrackingData}
      onNotificationsClick={openNotifications}
      onSearchClick={() =>
        navigate(
          activeSearchId
            ? `/scout/searches/${activeSearchId}`
            : "/scout/searches",
        )
      }
      onOpenProfile={() => navigate("/scout/profile")}
      onOpenAthleteDetail={handleOpenAthleteDetail}
    />
  );
};

export default RecruiterSummaryRoute;
